/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Nda_Download_FailedInputs */



/**
* | output |
* | --- |
* | "Could not download your NDA copy." |
*
* @param {Nda_Download_FailedInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const nda_download_failed = /** @type {((inputs?: Nda_Download_FailedInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Nda_Download_FailedInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Impossible de télécharger votre copie du NDA.")
	if (locale === "es") return /** @type {LocalizedString} */ ("No se pudo descargar su copia del NDA.")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Não foi possível baixar sua cópia do NDA.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Impossibile scaricare la tua copia del NDA.")
	return /** @type {LocalizedString} */ ("Could not download your NDA copy.")
});